import React from 'react';

// Components
import WpBadge from 'Wpds/components/badge/WpBadge';

// Styles
import './SelectedFilters.scss';

type Props = {
  selectedFilters: Array<any>;
  removeFilter: Function;
};

const SelectedFilters = ({ selectedFilters, removeFilter }: Props) => {
  const baseClassName = 'SelectedFilters';

  return (
    <div className={baseClassName}>
      {selectedFilters.map(filter => (
        <div className={`${baseClassName}__filter`}>
          <WpBadge
            size="lg"
            onDismiss={() => {
              removeFilter(filter);
            }}
          >
            {filter.label}
          </WpBadge>
        </div>
      ))}
    </div>
  );
};
export default SelectedFilters;
